export default "__VITE_ASSET__DXqH$CYr__"